<!--Presents recent activity in a news/blog article, or even department documents page.
    Requires at least one listing page to show up to the five most recent listings.
-->

<template>
  <main :class="`${this.block.value.color.color_choice}-color`">
    <mdb-container fluid>
      <mdb-row>
          <mdb-container>
            <mdb-row class="pt-5 px-2 justify-content-center" v-if="block.value.title_and_text">
              <mdb-col>
                <h2 v-if="block.value.title_and_text.title" class="pb-2" ><strong>{{block.value.title_and_text.title}}</strong></h2>
                <p v-if="block.value.title_and_text.text" >{{block.value.title_and_text.text}}</p>
              </mdb-col>
            </mdb-row>
            <mdb-row class="justify-content-center">
              <template v-for="page in block.value.listing_page">
                <recent_items_block :key="page.id" :block="page" :page_id="page.value.page.page_id"/>
              </template>
            </mdb-row>
          </mdb-container>
      </mdb-row>
    </mdb-container>
    <div :class="{ 'component-pattern': block.value.pattern.show_pattern}"></div>
  </main>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import recent_items_block from "@/components/streamfields/recent_items/recent_items_block.vue";

export default {
  props: {
    block: Object
  },
  name: "recent_items",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    recent_items_block
  }
};
</script>